/* ============================================================================
   wakaba-pickers  ―  わかばかぐ 製品ページ用 素材ピッカー（依存ゼロ Web Component）
   content.md Part 2 の実装。<script> 1本 ＋ カスタム要素タグだけで動く。
   - <wakaba-fabric-picker> : 張地（34色 / cloth・denim）を line item property で送信
   - <wakaba-wood-picker>   : 木材4種。既存 variant <select> を駆動（sync）か property
   スタイルは <head> に一度だけ自動注入（接頭辞 wkb-）。後読み CSS（custom.css）で上書き可。
   ============================================================================ */
(function () {
  'use strict';
  if (window.__wakabaPickersLoaded) return;
  window.__wakabaPickersLoaded = true;

  /* ---- 既定データ（張地40色＝シリーズ別。価格は全て同じ）------------------
     シリーズ＝生地ブランドで分類（label）＋メーカー名（description）。
     コード接頭辞: A=アネルカ/B=バトン/C=クレオ（モリデン）, CNT=コント/LA=ラルク/COL=クール（東京シンコール）,
     5xxx=パール（シンコール）, DENIM=デニム（篠原テキスタイル）。
     family＝「カラーから選択」モードの色系統（FAMILIES）。実物スウォッチの色味で割当
     （例: A-MH マホガニー＝ワイン系→red、A-MS ミモザ＝黄系→yellow、C-CA キャメル／COL-MC モカ＝茶系→brown）。
     ※デニムパッチワークは製品により不可。<wakaba-fabric-picker no-patchwork> で除外する。 */
  var DEFAULT_FABRIC = {
    series: [
      {
        id: 'anneluka', label: 'アネルカ', maker: 'モリデン',
        description: 'モリデン｜落ち着いた色から差し色まで。',
        colors: [
          { code: 'A-LB',  name: 'ライトブルー',     family: 'blue' },
          { code: 'A-MH',  name: 'マホガニー',       family: 'red' },
          { code: 'A-MS',  name: 'ミモザ',           family: 'yellow' },
          { code: 'A-CGR', name: 'チャコールグレー', family: 'gray' },
          { code: 'A-DB',  name: 'ダークブルー',     family: 'blue' },
          { code: 'A-G',   name: 'グリーン',         family: 'green' },
          { code: 'A-PI',  name: 'ピンク',           family: 'red' },
          { code: 'A-GR',  name: 'グレー',           family: 'gray' },
          { code: 'A-OR',  name: 'オレンジ',         family: 'yellow' }
        ]
      },
      {
        id: 'baton', label: 'バトン', maker: 'モリデン',
        description: 'モリデン',
        colors: [
          { code: 'B-DOR', name: 'ディープオレンジ', family: 'yellow' },
          { code: 'B-MT',  name: 'マスタード',       family: 'yellow' },
          { code: 'B-BR',  name: 'ブラウン',         family: 'brown' }
        ]
      },
      {
        id: 'creo', label: 'クレオ', maker: 'モリデン',
        description: 'モリデン',
        colors: [
          { code: 'C-CA',  name: 'キャメル', family: 'brown' },
          { code: 'C-GR',  name: 'グレー',   family: 'gray' },
          { code: 'C-BL',  name: 'ブラック', family: 'black' }
        ]
      },
      {
        id: 'conte', label: 'コント', maker: '東京シンコール',
        description: '東京シンコール',
        colors: [
          { code: 'CNT-BK', name: 'ブラック',       family: 'black' },
          { code: 'CNT-DG', name: 'ダークグリーン', family: 'green' },
          { code: 'CNT-BE', name: 'ベージュ',       family: 'beige' },
          { code: 'CNT-BR', name: 'ブラウン',       family: 'brown' },
          { code: 'CNT-GY', name: 'グレー',         family: 'gray' },
          { code: 'CNT-IV', name: 'アイボリー',     family: 'beige' }
        ]
      },
      {
        id: 'larc', label: 'ラルク', maker: '東京シンコール',
        description: '東京シンコール',
        colors: [
          { code: 'LA-NV',  name: 'ネイビー',       family: 'blue' },
          { code: 'LA-DGY', name: 'ダークグレー',   family: 'gray' },
          { code: 'LA-SBL', name: 'スカイブルー',   family: 'blue' },
          { code: 'LA-DGR', name: 'ダークグリーン', family: 'green' },
          { code: 'LA-CF',  name: 'コーヒー',       family: 'brown' },
          { code: 'LA-BE',  name: 'ベージュ',       family: 'beige' }
        ]
      },
      {
        id: 'cool', label: 'クール', maker: '東京シンコール',
        description: '東京シンコール',
        colors: [
          { code: 'COL-DBR', name: 'ダークブラウン', family: 'brown' },
          { code: 'COL-MC',  name: 'モカ',           family: 'brown' },
          { code: 'COL-GY',  name: 'グレー',         family: 'gray' },
          { code: 'COL-OR',  name: 'オレンジ',       family: 'yellow' },
          { code: 'COL-LBL', name: 'ライトブルー',   family: 'blue' }
        ]
      },
      {
        id: 'pearl', label: 'パール', maker: 'シンコール',
        description: 'シンコール',
        colors: [
          { code: '5109', name: 'レッド',         family: 'red' },
          { code: '5111', name: 'イエロー',       family: 'yellow' },
          { code: '5113', name: 'パープル',       family: 'red' },
          { code: '5116', name: 'ブルー',         family: 'blue' },
          { code: '5118', name: 'ダークブラウン', family: 'brown' }
        ]
      },
      {
        id: 'denim', label: 'デニム', maker: '篠原テキスタイル',
        description: '篠原テキスタイル｜色落ちと風合いを楽しむデニム。',
        colors: [
          { code: 'DENIM-L', name: 'デニムライト',     family: 'denim' },
          { code: 'DENIM-M', name: 'デニムミディアム', family: 'denim' },
          { code: 'DENIM-D', name: 'デニムダーク',     family: 'denim' },
          { code: 'DENIM-Patchwork', name: 'デニムパッチワーク', family: 'denim', patchwork: true }
        ]
      }
    ]
  };

  // 「カラーから選択」モードの色系統（表示順）。muku-store の「カラーから選択」を参考に
  // 全色を色系統でまとめたフラット表示にする。パープル系は点数が少ないため赤・ピンクに含める。
  var FAMILIES = [
    { id: 'blue',   label: '青' },
    { id: 'green',  label: '緑' },
    { id: 'red',    label: '赤・ピンク' },
    { id: 'yellow', label: '黄・オレンジ' },
    { id: 'brown',  label: '茶' },
    { id: 'gray',   label: 'グレー' },
    { id: 'beige',  label: 'ベージュ・アイボリー' },
    { id: 'black',  label: '黒' },
    { id: 'denim',  label: 'デニム' }
  ];

  var DEFAULT_WOOD = [
    { code: 'WA', name: 'ホワイトアッシュ' },
    { code: 'OK', name: 'レッドオーク' },
    { code: 'CH', name: 'ブラックチェリー' },
    { code: 'WN', name: 'ウォールナット' }
  ];

  // コード/和名 → スウォッチ画像。桧（ひのき）は wood-hi.jpg を共用。
  var WOOD_IMG = {
    'WA': 'wood-wa.jpg', 'OK': 'wood-ok.jpg', 'CH': 'wood-ch.jpg', 'WN': 'wood-wn.jpg',
    'HI': 'wood-hi.jpg', '桧': 'wood-hi.jpg', '檜': 'wood-hi.jpg', 'ひのき': 'wood-hi.jpg', 'ヒノキ': 'wood-hi.jpg',
    'ホワイトアッシュ': 'wood-wa.jpg', 'レッドオーク': 'wood-ok.jpg', 'ブラックチェリー': 'wood-ch.jpg', 'ウォールナット': 'wood-wn.jpg'
  };
  var WOOD_SEP = /[\s:：\-－―ｰ｜|・／/]+/;

  // 既存の variant <select> の option 値（例「OK：レッドオーク」「桧：ひのき」）から
  // 木材リストを自動導出する。製品ごとに選べる樹種だけを picker に出すための要。
  function deriveWoodFromSelect(sel) {
    var s = document.querySelector(sel);
    if (!s) return null;
    var out = [];
    Array.prototype.forEach.call(s.options, function (o) {
      var v = (o.value || '').trim();
      if (!v) return;
      var code = v.split(WOOD_SEP)[0];
      var name = v.slice(code.length).replace(/^[\s:：\-－―ｰ｜|・／/]+/, '');
      if (!name) name = (o.text || code).trim();
      var file = WOOD_IMG[code] || WOOD_IMG[name] || ('wood-' + code.toLowerCase() + '.jpg');
      out.push({ code: code, name: name, file: file });
    });
    return out;
  }

  /* ---- スタイル（自動注入・接頭辞 wkb-）-------------------------------- */
  var STYLE = [
    '.wkb-picker{margin:1.5rem 0;color:#1a1a1a;font-family:inherit}',
    '.wkb-picker__legend{display:flex;align-items:baseline;gap:.5em;margin-bottom:.75rem;font-size:.95rem;font-weight:500}',
    '.wkb-picker__legend small{font-size:.78rem;font-weight:400;opacity:.6}',
    '.wkb-picker__selected{font-size:.82rem;opacity:.7;margin-left:auto;font-weight:400}',
    '.wkb-fabric__modes{display:inline-flex;margin-bottom:.85rem;border:1px solid rgba(0,0,0,.22);border-radius:2px;overflow:hidden}',
    '.wkb-fabric__mode{appearance:none;border:0;background:transparent;color:inherit;padding:.45em 1.3em;cursor:pointer;font:inherit;font-size:clamp(12px,1vw,13px);letter-spacing:.05em}',
    '.wkb-fabric__mode+.wkb-fabric__mode{border-left:1px solid rgba(0,0,0,.22)}',
    '.wkb-fabric__mode[aria-selected="true"]{background:#1a1a1a;color:#fff}',
    '.wkb-fabric__tabs{display:flex;gap:.5rem;margin-bottom:.75rem;flex-wrap:wrap}',
    '.wkb-fabric__tab{appearance:none;border:1px solid rgba(0,0,0,.18);background:transparent;color:inherit;padding:.35em 1em;border-radius:2px;cursor:pointer;font:inherit;font-size:.85rem;letter-spacing:.04em}',
    '.wkb-fabric__tab[aria-selected="true"]{background:#1a1a1a;color:#fff;border-color:#1a1a1a}',
    '.wkb-fabric__desc{font-size:.8rem;opacity:.65;margin:0 0 .75rem}',
    '.wkb-fabric__family{font-size:clamp(13px,1.1vw,14px);font-weight:500;letter-spacing:.05em;margin:1.2rem 0 .55rem;padding-bottom:.3rem;border-bottom:1px solid rgba(0,0,0,.1)}',
    '.wkb-fabric__family:first-child{margin-top:0}',
    '.wkb-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(80px,1fr));gap:.7rem}',
    // color を明示：iOS Safari は <button> のテキスト色を継承せずシステム既定（青）になるため
    '.wkb-swatch{appearance:none;border:0;background:none;padding:0;cursor:pointer;text-align:center;font:inherit;color:#1a1a1a;display:flex;flex-direction:column;align-items:stretch}',
    '.wkb-swatch__img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:2px;border:2px solid transparent;background:#eee}',
    '.wkb-swatch[aria-checked="true"] .wkb-swatch__img{border-color:#1a1a1a;box-shadow:0 0 0 2px #fff inset}',
    '.wkb-swatch__name{display:flex;align-items:center;justify-content:center;text-align:center;min-height:2.7em;font-size:clamp(13px,1.1vw,14px);line-height:1.35;margin-top:.4rem;opacity:.9;overflow-wrap:break-word}',
    '.wkb-swatch__code{display:block;font-size:clamp(11px,0.9vw,12px);line-height:1.25;margin-top:.15rem;opacity:.5;letter-spacing:.03em}',
    '.wkb-wood__row{display:grid;grid-template-columns:repeat(auto-fill,minmax(84px,1fr));gap:.75rem}',
    '.wkb-wood__swatch{appearance:none;border:0;background:none;padding:0;cursor:pointer;text-align:center;font:inherit;color:#1a1a1a;display:flex;flex-direction:column}',
    '.wkb-wood__img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:2px;border:2px solid rgba(0,0,0,.12)}',
    '.wkb-wood__swatch[aria-checked="true"] .wkb-wood__img{border-color:#1a1a1a;box-shadow:0 0 0 2px #fff inset}',
    '.wkb-wood__name{display:flex;align-items:center;justify-content:center;text-align:center;min-height:2.7em;font-size:clamp(13px,1.1vw,14px);line-height:1.35;margin-top:.4rem}',
    // 未選択バリデーション：エラー表示／動的決済ボタンの無効化
    '.wkb-error{display:none;align-items:center;gap:.4em;margin:.2rem 0 .7rem;color:#c0392b;font-size:clamp(12px,1vw,13px);font-weight:500}',
    '.wkb-picker.wkb-invalid .wkb-error{display:flex}',
    '.wkb-picker.wkb-invalid .wkb-picker__legend>span:first-child{color:#c0392b}',
    '.wkb-error svg{width:1.1em;height:1.1em;flex:none}',
    '.shopify-payment-button.wkb-dc-blocked{opacity:.45;pointer-events:none}',
    '.wkb-hidden{display:none!important}'
  ].join('');

  var ERR_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>';

  function injectStyles() {
    if (document.getElementById('wakaba-pickers-styles')) return;
    var s = document.createElement('style');
    s.id = 'wakaba-pickers-styles';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  /* ---- ユーティリティ -------------------------------------------------- */
  // 画像のバージョン付きURLマップ（Liquid から img-map 属性で受け取る）。
  // 同名ファイルを差し替えても asset_url の ?v=ハッシュ が変わるため、ここにある画像は
  // ファイル別に即時キャッシュ更新される。マップに無いファイルは従来どおり base+file で解決。
  var IMG_MAP = {};
  function mergeImgMap(el) {
    var raw = el && el.getAttribute('img-map');
    if (!raw) return;
    try {
      var m = JSON.parse(raw);
      for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k)) IMG_MAP[k] = m[k]; }
    } catch (e) {}
  }
  // innerHTML に差し込む文字列のエスケープ（defense-in-depth）。
  // 名称類は商品オプション由来＝管理者設定だが、念のため属性/本文両用で無害化する。
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fileFor(prefix, code) {
    return prefix + code.toLowerCase().replace(/\s+/g, '') + '.jpg';
  }
  function resolveUrl(base, file) {
    if (/^(https?:)?\/\//.test(file) || file.charAt(0) === '/') return file;
    if (IMG_MAP[file]) return IMG_MAP[file];
    return (base || './') + file;
  }
  function findCartForm(el, formId) {
    if (formId) {
      var f = document.getElementById(formId);
      if (f) return f;
    }
    return el.closest('form[action*="/cart/add"]') ||
           document.querySelector('form[action*="/cart/add"]');
  }

  /* ---- 未選択バリデーション ----------------------------------------------
     素材（木材）・張地が未選択のままカートに入る不具合を防ぐ。
     Context は submit を bubble フェーズの AJAX ハンドラ（theme.js ProductForm）で
     処理するため、ここでは form の submit を「キャプチャフェーズ」で先に捕まえて、
     未選択なら preventDefault + stopImmediatePropagation でテーマの追加処理ごと止める。
     （キャプチャは必ず bubble より先に走るので確実にブロックできる）
     「今すぐ購入」(動的決済ボタン) は line item property を運べないので、未選択中は無効化する。 */
  function pickersInForm(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('wakaba-wood-picker, wakaba-fabric-picker, wakaba-itaza-picker'));
  }
  function refreshDynamicCheckout(form) {
    if (!form) return;
    var incomplete = pickersInForm(form).some(function (p) {
      return typeof p.wakabaRequired === 'function' && p.wakabaRequired() &&
             typeof p.wakabaIsComplete === 'function' && !p.wakabaIsComplete();
    });
    Array.prototype.forEach.call(form.querySelectorAll('.shopify-payment-button'), function (dc) {
      dc.classList.toggle('wkb-dc-blocked', incomplete);
    });
  }
  function ensureFormValidation(form) {
    if (!form || form.__wakabaValidationBound) return;
    form.__wakabaValidationBound = true;
    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      pickersInForm(form).forEach(function (p) {
        var required = typeof p.wakabaRequired === 'function' && p.wakabaRequired();
        var ok = !required || (typeof p.wakabaIsComplete === 'function' && p.wakabaIsComplete());
        if (typeof p.wakabaSetError === 'function') p.wakabaSetError(!ok);
        if (!ok && !firstInvalid) firstInvalid = p;
      });
      if (firstInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // ローディング状態に入ったボタンを元に戻す（テーマは submit 直後に bttn--loading を付与）
        Array.prototype.forEach.call(form.querySelectorAll('.bttn--loading'), function (b) {
          b.classList.remove('bttn--loading');
        });
        if (firstInvalid.scrollIntoView) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, true); // capture フェーズ
  }

  /* ====================================================================== */
  /*  <wakaba-fabric-picker>                                                */
  /* ====================================================================== */
  function FabricPicker() { return Reflect.construct(HTMLElement, [], FabricPicker); }
  FabricPicker.prototype = Object.create(HTMLElement.prototype);
  FabricPicker.prototype.constructor = FabricPicker;

  FabricPicker.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    injectStyles();
    var self = this;
    var url = this.getAttribute('config-url');
    if (url) {
      fetch(url).then(function (r) { return r.json(); })
        .then(function (data) { self._data = data; self._render(); })
        .catch(function () { self._data = DEFAULT_FABRIC; self._render(); });
    } else {
      this._data = DEFAULT_FABRIC;
      this._render();
    }
  };

  FabricPicker.prototype._render = function () {
    var s = this._data, self = this;
    mergeImgMap(this);
    var base = this.getAttribute('asset-base') || './';
    var legend = this.getAttribute('legend') || '張地（ファブリック）';
    var legendSub = this.getAttribute('legend-sub') || '— 生地と色をお選びください';
    // 先頭「_」でカート/チェックアウトの顧客表示から隠す（生地メーカー名は出さない方針）。
    // 注文データには残るので、森さんは管理画面の注文でシリーズを確認できる。
    var keySeries = this.getAttribute('property-series') || '_ファブリックシリーズ';
    var keyColor = this.getAttribute('property-color') || 'ファブリック';
    var activeId = this.getAttribute('default-series') || s.series[0].id;
    // no-patchwork 属性：デニムパッチワーク不可の製品では patchwork:true の色を出さない
    this._noPatch = this.hasAttribute('no-patchwork');

    this.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'wkb-picker wkb-fabric';

    var lg = document.createElement('div');
    lg.className = 'wkb-picker__legend';
    lg.innerHTML = '<span>' + esc(legend) + '</span><small>' + esc(legendSub) + '</small>' +
      '<span class="wkb-picker__selected" data-selected></span>';
    root.appendChild(lg);

    // 未選択エラー（既定は非表示・wkb-invalid 時に表示）
    var err = document.createElement('p');
    err.className = 'wkb-error';
    err.setAttribute('role', 'alert');
    err.innerHTML = ERR_ICON + '<span>' + esc(this.getAttribute('error-text') || '張地をお選びください') + '</span>';
    root.appendChild(err);
    this._err = err; this._root = root;

    // モード切替（生地から選択／カラーから選択）。muku-store の2モード選択を参考。
    var modes = document.createElement('div');
    modes.className = 'wkb-fabric__modes';
    modes.setAttribute('role', 'tablist');
    [{ id: 'series', label: '生地から選択' }, { id: 'color', label: 'カラーから選択' }].forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wkb-fabric__mode';
      b.textContent = m.label;
      b.dataset.mode = m.id;
      b.setAttribute('aria-selected', m.id === 'series' ? 'true' : 'false');
      b.addEventListener('click', function () { self._setMode(m.id); });
      modes.appendChild(b);
    });
    root.appendChild(modes);

    // タブ（生地シリーズ・series モードのみ表示）
    var tabs = document.createElement('div');
    tabs.className = 'wkb-fabric__tabs';
    s.series.forEach(function (ser, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wkb-fabric__tab';
      b.dataset.seriesId = ser.id;
      // 生地メーカー名（アネルカ等）は出さず、通し番号のグループ名にする（Cloth1…Cloth7）。
      // デニムだけは通し番号ではなく「DENIM」表記にする。
      b.textContent = ser.id === 'denim' ? 'DENIM' : 'Cloth' + (i + 1);
      b.setAttribute('aria-selected', ser.id === activeId ? 'true' : 'false');
      b.addEventListener('click', function () { self._showSeries(ser.id); });
      tabs.appendChild(b);
    });
    root.appendChild(tabs);

    var desc = document.createElement('p');
    desc.className = 'wkb-fabric__desc';
    root.appendChild(desc);

    // グリッド置き場（series=単一グリッド / color=色系統ごとの見出し＋グリッド）
    var content = document.createElement('div');
    content.className = 'wkb-fabric__content';
    root.appendChild(content);

    // hidden inputs：カートフォームの子として直接挿入する。
    // ※ form 属性での関連付けは使わない。商品フォーム内の <select name="id"> による
    //    DOM clobbering で form.id が要素を指し、不正な form 属性で所有者が外れて
    //    FormData から除外される不具合があったため（descendant 挿入が最も確実）。
    var form = findCartForm(this, this.getAttribute('form'));
    function mkInput(name) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      return i;
    }
    this._inSeries = mkInput(keySeries);
    this._inColor = mkInput(keyColor);
    this._inCode = mkInput(keyColor + 'コード'); // 顧客にも表示（例「ファブリックコード: A-G」）。発注時の識別に使う
    var sink = form || root;
    sink.appendChild(this._inSeries);
    sink.appendChild(this._inColor);
    sink.appendChild(this._inCode);

    this._refs = { content: content, desc: desc, tabs: tabs, modes: modes, selected: lg.querySelector('[data-selected]'), base: base };
    this.appendChild(root);
    this._mode = 'series';
    this._showSeries(activeId);

    // 未選択バリデーションをフォームに紐付け
    this._cartForm = form;
    ensureFormValidation(form);
    refreshDynamicCheckout(form);
  };

  // 張地は表示されている＝必須。色を1つ選ぶまで未完了。
  // ただし座面が「板座」のときは布張り（生地）は対象外なので不要。
  FabricPicker.prototype.wakabaRequired = function () {
    if (this._cartForm && this._cartForm.dataset.wkbSeat === '板座') return false;
    return !!(this._data && this._data.series && this._data.series.length);
  };
  FabricPicker.prototype.wakabaIsComplete = function () {
    return !!this._selectedCode;
  };
  FabricPicker.prototype.wakabaSetError = function (show) {
    if (this._root) this._root.classList.toggle('wkb-invalid', !!show);
  };
  // 座面切替で布張りが対象外になったとき、生地の選択・hidden値をクリア（古い色がカートに載らないように）
  FabricPicker.prototype.wakabaClear = function () {
    this._selectedCode = null;
    if (this._inSeries) this._inSeries.value = '';
    if (this._inColor) this._inColor.value = '';
    if (this._inCode) this._inCode.value = '';
    if (this._refs && this._refs.selected) this._refs.selected.textContent = '';
    if (this._root) {
      Array.prototype.forEach.call(this._root.querySelectorAll('.wkb-swatch[aria-checked="true"]'),
        function (b) { b.setAttribute('aria-checked', 'false'); });
    }
    this.wakabaSetError(false);
  };

  // スウォッチボタンを1つ生成（series/color 両モード共通）。
  // withSeries=true（color モード）では品番行に生地名を併記（例「アネルカ｜A-G」）。
  FabricPicker.prototype._mkSwatch = function (ser, c) {
    var self = this, r = this._refs;
    var file = c.file || fileFor('swatch-', c.code);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wkb-swatch';
    btn.dataset.code = c.code;
    btn.setAttribute('aria-checked', (this._selectedCode === c.code) ? 'true' : 'false');
    // 品番表記：A-/B-/5xxx 等は色名の下にコードを併記。デニムは名前で自明なので省略。
    var showCode = c.code && c.code.indexOf('DENIM') !== 0;
    // 品番（例 A-LB）のみ表示。生地メーカー名（アネルカ等）は両モードとも出さない。
    var codeText = showCode ? c.code : '';
    btn.title = showCode ? (c.name + '（' + c.code + '）') : c.name;
    btn.innerHTML =
      '<img class="wkb-swatch__img" loading="lazy" alt="' + esc(c.name) + '" src="' + resolveUrl(r.base, file) + '">' +
      '<span class="wkb-swatch__name">' + esc(c.name) + '</span>' +
      (codeText ? '<small class="wkb-swatch__code">' + esc(codeText) + '</small>' : '');
    btn.addEventListener('click', function () { self._select(ser, c); });
    return btn;
  };

  // モード切替。series=生地タブ＋単一グリッド / color=色系統ごとのフラット表示。
  FabricPicker.prototype._setMode = function (mode) {
    if (this._mode === mode) return;
    this._mode = mode;
    var r = this._refs;
    Array.prototype.forEach.call(r.modes.children, function (b) {
      b.setAttribute('aria-selected', b.dataset.mode === mode ? 'true' : 'false');
    });
    if (mode === 'color') {
      r.tabs.style.display = 'none';
      this._showFamilies();
    } else {
      r.tabs.style.display = '';
      this._showSeries(this._activeSeries || this._data.series[0].id);
    }
  };

  FabricPicker.prototype._showSeries = function (id) {
    var self = this, r = this._refs;
    var ser = this._data.series.filter(function (x) { return x.id === id; })[0];
    if (!ser) return;
    this._activeSeries = id;
    Array.prototype.forEach.call(r.tabs.children, function (b) {
      b.setAttribute('aria-selected', b.dataset.seriesId === ser.id ? 'true' : 'false');
    });
    // メーカー名・説明は製品ページには出さない（生地名＋色のみ）。詳細は別の生地紹介ページで。
    r.desc.textContent = '';
    r.desc.style.display = 'none';
    r.content.innerHTML = '';
    var grid = document.createElement('div');
    grid.className = 'wkb-grid';
    ser.colors.forEach(function (c) {
      if (self._noPatch && c.patchwork) return;
      grid.appendChild(self._mkSwatch(ser, c));
    });
    r.content.appendChild(grid);
  };

  // 「カラーから選択」：全シリーズの色を FAMILIES の色系統でまとめてフラット表示
  FabricPicker.prototype._showFamilies = function () {
    var self = this, r = this._refs;
    r.desc.textContent = '';
    r.desc.style.display = 'none';
    r.content.innerHTML = '';
    FAMILIES.forEach(function (fam) {
      var items = [];
      self._data.series.forEach(function (ser) {
        ser.colors.forEach(function (c) {
          if (self._noPatch && c.patchwork) return;
          if ((c.family || 'other') === fam.id) items.push({ ser: ser, c: c });
        });
      });
      if (!items.length) return;
      var h = document.createElement('p');
      h.className = 'wkb-fabric__family';
      h.textContent = fam.label;
      r.content.appendChild(h);
      var grid = document.createElement('div');
      grid.className = 'wkb-grid';
      items.forEach(function (it) { grid.appendChild(self._mkSwatch(it.ser, it.c)); });
      r.content.appendChild(grid);
    });
  };

  FabricPicker.prototype._select = function (ser, c) {
    this._selectedCode = c.code;
    this._inSeries.value = ser.label;
    this._inColor.value = c.name;
    this._inCode.value = c.code;
    // 同名（例「ダークグリーン」）が複数あるため、必ずコードで一意に判定する
    // color モードはグリッドが複数あるので content 配下を一括走査する
    Array.prototype.forEach.call(this._refs.content.querySelectorAll('.wkb-swatch'), function (b) {
      b.setAttribute('aria-checked', b.dataset.code === c.code ? 'true' : 'false');
    });
    var selCode = (c.code && c.code.indexOf('DENIM') !== 0) ? '（' + c.code + '）' : '';
    // 表示ラベルは色名＋コードのみ（生地ブランド名 ser.label は出さない方針）。
    // 注文データ用の _inSeries には ser.label を残すので、森さんは管理画面でシリーズを確認できる。
    this._refs.selected.textContent = c.name + selCode;
    this.wakabaSetError(false);
    refreshDynamicCheckout(this._cartForm);
    this.dispatchEvent(new CustomEvent('wakaba:fabric-change', {
      bubbles: true, detail: { series: ser.label, code: c.code, name: c.name }
    }));
  };

  /* ====================================================================== */
  /*  <wakaba-wood-picker>                                                  */
  /* ====================================================================== */
  function WoodPicker() { return Reflect.construct(HTMLElement, [], WoodPicker); }
  WoodPicker.prototype = Object.create(HTMLElement.prototype);
  WoodPicker.prototype.constructor = WoodPicker;

  WoodPicker.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    injectStyles();
    this._render();
  };

  WoodPicker.prototype._render = function () {
    var self = this;
    mergeImgMap(this);
    var base = this.getAttribute('asset-base') || './';
    var legend = this.getAttribute('legend') || '素材';
    var options = DEFAULT_WOOD;
    var optAttr = this.getAttribute('options');
    if (optAttr) {
      try { options = JSON.parse(optAttr); } catch (e) {}
    } else if (this.hasAttribute('auto')) {
      // auto モード：対象 <select> の値から、その製品で選べる樹種だけを導出
      var ts = this.getAttribute('target-select');
      if (ts) {
        var derived = deriveWoodFromSelect(ts);
        if (derived && derived.length) options = derived;
      }
    }

    this.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'wkb-picker wkb-wood';
    root.innerHTML = '<div class="wkb-picker__legend"><span>' + esc(legend) +
      '</span><span class="wkb-picker__selected" data-selected></span></div>';
    this._root = root;

    // 未選択エラー（既定は非表示）
    var err = document.createElement('p');
    err.className = 'wkb-error';
    err.setAttribute('role', 'alert');
    err.innerHTML = ERR_ICON + '<span>' + esc(this.getAttribute('error-text') || (legend + 'をお選びください')) + '</span>';
    root.appendChild(err);
    this._err = err;

    var row = document.createElement('div');
    row.className = 'wkb-wood__row';
    root.appendChild(row);

    // property モード用 hidden input（カートフォームの子として直接挿入）
    var targetSel = this.getAttribute('target-select');
    var cartForm = findCartForm(this, this.getAttribute('form'));
    if (!targetSel) {
      var key = this.getAttribute('property') || '木材';
      this._inProp = document.createElement('input');
      this._inProp.type = 'hidden';
      this._inProp.name = 'properties[' + key + ']';
      (cartForm || root).appendChild(this._inProp);
    }

    options.forEach(function (w) {
      var file = w.file || fileFor('wood-', w.code);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wkb-wood__swatch';
      btn.setAttribute('aria-checked', 'false');
      btn.title = w.name;
      btn.innerHTML =
        '<img class="wkb-wood__img" loading="lazy" alt="' + esc(w.name) + '" src="' + resolveUrl(base, file) + '">' +
        '<span class="wkb-wood__name">' + esc(w.name) + '</span>';
      btn.addEventListener('click', function () { self._select(w, row); });
      row.appendChild(btn);
    });

    this._refs = { row: row, selected: root.querySelector('[data-selected]') };
    this._optCount = options.length;
    this.appendChild(root);

    // 未選択バリデーションをフォームに紐付け
    this._cartForm = cartForm;
    ensureFormValidation(cartForm);
    refreshDynamicCheckout(cartForm);
  };

  // 木材ピッカーは表示されている＝必須。クリックして1つ選ぶまで未完了。
  // （sync モードでは variant select が先頭にデフォルト選択されているが、
  //   どの素材か明示的に選ばせるため、ユーザーの選択操作を必須とする）
  WoodPicker.prototype.wakabaRequired = function () {
    return this._optCount > 0;
  };
  WoodPicker.prototype.wakabaIsComplete = function () {
    return !!this._selectedWood;
  };
  WoodPicker.prototype.wakabaSetError = function (show) {
    if (this._root) this._root.classList.toggle('wkb-invalid', !!show);
  };

  WoodPicker.prototype._select = function (w, row) {
    Array.prototype.forEach.call(row.querySelectorAll('.wkb-wood__swatch'), function (b) {
      b.setAttribute('aria-checked', b.title === w.name ? 'true' : 'false');
    });
    this._refs.selected.textContent = w.name;
    this._selectedWood = w.code;
    this.wakabaSetError(false);
    refreshDynamicCheckout(this._cartForm);

    var targetSel = this.getAttribute('target-select');
    if (targetSel) {
      // sync モード：value が「コードで始まる」option を選択し change を発火
      var select = document.querySelector(targetSel);
      if (select) {
        var matched = null;
        Array.prototype.forEach.call(select.options, function (o) {
          var v = (o.value || '').trim();
          if (matched) return;
          // 「WN」「WN ウォールナット」「WN：…」等を許容
          if (v === w.code || v.indexOf(w.code) === 0) {
            var rest = v.slice(w.code.length);
            if (v === w.code || /^[\s:：\-－｜|・]/.test(rest)) matched = o.value;
          }
        });
        if (matched != null) {
          select.value = matched;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else if (this._inProp) {
      this._inProp.value = w.name;
    }

    this.dispatchEvent(new CustomEvent('wakaba:wood-change', {
      bubbles: true, detail: { code: w.code, name: w.name }
    }));
  };

  /* ====================================================================== */
  /*  <wakaba-seat-picker>  座面（布張り / 板座）トグル                       */
  /*  native の「座面」variant select を駆動して価格を更新し、布張り→生地ピッカー /  */
  /*  板座→板座ピッカー の表示を切り替える。対象外側の選択はクリアする。           */
  /* ====================================================================== */
  function SeatPicker() { return Reflect.construct(HTMLElement, [], SeatPicker); }
  SeatPicker.prototype = Object.create(HTMLElement.prototype);
  SeatPicker.prototype.constructor = SeatPicker;

  SeatPicker.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    injectStyles();
    this._render();
  };

  SeatPicker.prototype._render = function () {
    var self = this;
    var legend = this.getAttribute('legend') || '座面';
    var targetSel = this.getAttribute('target-select');
    this._select = targetSel ? document.querySelector(targetSel) : null;
    this._cartForm = findCartForm(this, this.getAttribute('form'));

    var values = [];
    if (this._select) {
      Array.prototype.forEach.call(this._select.options, function (o) {
        var v = (o.value || '').trim(); if (v) values.push(v);
      });
    }
    if (!values.length) values = ['布張り', '板座'];

    this.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'wkb-picker wkb-seat';
    root.innerHTML = '<div class="wkb-picker__legend"><span>' + esc(legend) + '</span></div>';

    var modes = document.createElement('div');
    modes.className = 'wkb-fabric__modes';
    values.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wkb-fabric__mode';
      b.textContent = v;
      b.dataset.value = v;
      b.setAttribute('aria-selected', 'false');
      b.addEventListener('click', function () { self._choose(v, false); });
      modes.appendChild(b);
    });
    root.appendChild(modes);
    this._modes = modes;
    this.appendChild(root);

    var initial = (this._select && this._select.value) ? this._select.value.trim() : values[0];
    if (values.indexOf(initial) < 0) initial = values[0];
    this._choose(initial, true);
  };

  SeatPicker.prototype._choose = function (value, silent) {
    this._mode = value;
    Array.prototype.forEach.call(this._modes.querySelectorAll('.wkb-fabric__mode'), function (b) {
      b.setAttribute('aria-selected', b.dataset.value === value ? 'true' : 'false');
    });
    // native の座面 select を同期して価格を更新（初期化時は既に同値なのでスキップ）
    if (this._select && !silent && this._select.value !== value) {
      this._select.value = value;
      this._select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // フォームに座面モードを記録（fabric / itaza の必須判定が参照）
    if (this._cartForm) this._cartForm.dataset.wkbSeat = value;

    // サブピッカーの表示切替＋対象外側のクリア
    var scope = this._cartForm || document;
    var isItaza = value === '板座';
    var fab = scope.querySelector('wakaba-fabric-picker');
    var ita = scope.querySelector('wakaba-itaza-picker');
    if (fab) { fab.classList.toggle('wkb-hidden', isItaza); if (isItaza && typeof fab.wakabaClear === 'function') fab.wakabaClear(); }
    if (ita) { ita.classList.toggle('wkb-hidden', !isItaza); if (!isItaza && typeof ita.wakabaClear === 'function') ita.wakabaClear(); }

    refreshDynamicCheckout(this._cartForm);
    this.dispatchEvent(new CustomEvent('wakaba:seat-change', { bubbles: true, detail: { mode: value } }));
  };

  /* ====================================================================== */
  /*  <wakaba-itaza-picker>  板座の木材（WN / 本体素材と同じ）                 */
  /*  本体（素材）の木材ピッカーの選択（wakaba:wood-change）に追従し、         */
  /*  「本体と同じ」のアイコン・名称を動的に切り替える。本体=WN のときは重複の  */
  /*  ため「本体と同じ」を出さず WN のみ。値は line item property で送信。       */
  /* ====================================================================== */
  function ItazaPicker() { return Reflect.construct(HTMLElement, [], ItazaPicker); }
  ItazaPicker.prototype = Object.create(HTMLElement.prototype);
  ItazaPicker.prototype.constructor = ItazaPicker;

  ItazaPicker.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    injectStyles();
    this._render();
  };

  ItazaPicker.prototype._render = function () {
    var self = this;
    mergeImgMap(this);
    this._base = this.getAttribute('asset-base') || './';
    var legend = this.getAttribute('legend') || '板座の木材';
    var key = this.getAttribute('property') || '板座の素材';
    this._cartForm = findCartForm(this, this.getAttribute('form'));
    this._bodySel = this.getAttribute('body-select');

    this.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'wkb-picker wkb-wood wkb-itaza';
    root.innerHTML = '<div class="wkb-picker__legend"><span>' + esc(legend) +
      '</span><span class="wkb-picker__selected" data-selected></span></div>';
    this._root = root;

    var err = document.createElement('p');
    err.className = 'wkb-error';
    err.setAttribute('role', 'alert');
    err.innerHTML = ERR_ICON + '<span>' + esc(this.getAttribute('error-text') || (legend + 'をお選びください')) + '</span>';
    root.appendChild(err);

    var row = document.createElement('div');
    row.className = 'wkb-wood__row';
    root.appendChild(row);
    this._row = row;

    this._inProp = document.createElement('input');
    this._inProp.type = 'hidden';
    this._inProp.name = 'properties[' + key + ']';
    (this._cartForm || root).appendChild(this._inProp);

    this.appendChild(root);

    this._bodyWood = this._readBodyWood();
    this._build();

    // 本体（素材）の選択変更に追従して「本体と同じ」を更新
    document.addEventListener('wakaba:wood-change', function (e) {
      if (!e.detail || !e.detail.code) return;
      self._bodyWood = { code: e.detail.code, name: e.detail.name };
      self._build();
    });

    ensureFormValidation(this._cartForm);
    refreshDynamicCheckout(this._cartForm);
  };

  ItazaPicker.prototype._readBodyWood = function () {
    if (!this._bodySel) return null;
    var s = document.querySelector(this._bodySel);
    if (!s || !s.value) return null;
    var v = s.value.trim();
    var code = v.split(WOOD_SEP)[0];
    var name = v.slice(code.length).replace(/^[\s:：\-－―ｰ｜|・／/]+/, '') || v;
    return { code: code, name: name };
  };

  ItazaPicker.prototype._options = function () {
    var opts = [{ kind: 'wn', label: 'ウォールナット', file: WOOD_IMG['WN'] }];
    var body = this._bodyWood;
    if (body && body.code && body.code !== 'WN') {
      var file = WOOD_IMG[body.code] || WOOD_IMG[body.name] || ('wood-' + body.code.toLowerCase() + '.jpg');
      opts.push({ kind: 'same', label: '本体と同じ（' + body.name + '）', file: file });
    }
    return opts;
  };

  ItazaPicker.prototype._build = function () {
    var self = this;
    var opts = this._options();
    this._row.innerHTML = '';
    opts.forEach(function (o) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wkb-wood__swatch';
      btn.dataset.kind = o.kind;
      btn.setAttribute('aria-checked', self._selectedKind === o.kind ? 'true' : 'false');
      btn.title = o.label;
      btn.innerHTML =
        '<img class="wkb-wood__img" loading="lazy" alt="' + esc(o.label) + '" src="' + resolveUrl(self._base, o.file) + '">' +
        '<span class="wkb-wood__name">' + esc(o.label) + '</span>';
      btn.addEventListener('click', function () { self._select(o); });
      self._row.appendChild(btn);
    });
    // 本体がWNになり「本体と同じ」が消えたのに、それを選んでいたら選択解除
    if (this._selectedKind === 'same' && opts.length === 1) {
      this._selectedKind = null;
      if (this._inProp) this._inProp.value = '';
      var sel0 = this._root.querySelector('[data-selected]'); if (sel0) sel0.textContent = '';
    } else if (this._selectedKind) {
      // 選択中の表示・property を最新化（本体と同じ の樹種名が変わるため）
      var cur = opts.filter(function (o) { return o.kind === self._selectedKind; })[0];
      if (cur) this._applySelection(cur);
    }
  };

  ItazaPicker.prototype._select = function (o) {
    this._selectedKind = o.kind;
    this._applySelection(o);
    this.wakabaSetError(false);
    refreshDynamicCheckout(this._cartForm);
  };

  ItazaPicker.prototype._applySelection = function (o) {
    var self = this;
    Array.prototype.forEach.call(this._row.querySelectorAll('.wkb-wood__swatch'), function (b) {
      b.setAttribute('aria-checked', b.dataset.kind === self._selectedKind ? 'true' : 'false');
    });
    var sel = this._root.querySelector('[data-selected]'); if (sel) sel.textContent = o.label;
    if (this._inProp) this._inProp.value = o.label;
  };

  ItazaPicker.prototype.wakabaRequired = function () {
    return !!(this._cartForm && this._cartForm.dataset.wkbSeat === '板座');
  };
  ItazaPicker.prototype.wakabaIsComplete = function () {
    return !!this._selectedKind;
  };
  ItazaPicker.prototype.wakabaSetError = function (show) {
    if (this._root) this._root.classList.toggle('wkb-invalid', !!show);
  };
  ItazaPicker.prototype.wakabaClear = function () {
    this._selectedKind = null;
    if (this._inProp) this._inProp.value = '';
    if (this._root) {
      var s = this._root.querySelector('[data-selected]'); if (s) s.textContent = '';
      Array.prototype.forEach.call(this._root.querySelectorAll('.wkb-wood__swatch[aria-checked="true"]'),
        function (b) { b.setAttribute('aria-checked', 'false'); });
    }
    this.wakabaSetError(false);
  };

  /* ---- 登録 ------------------------------------------------------------ */
  if (!customElements.get('wakaba-fabric-picker')) customElements.define('wakaba-fabric-picker', FabricPicker);
  if (!customElements.get('wakaba-wood-picker')) customElements.define('wakaba-wood-picker', WoodPicker);
  if (!customElements.get('wakaba-seat-picker')) customElements.define('wakaba-seat-picker', SeatPicker);
  if (!customElements.get('wakaba-itaza-picker')) customElements.define('wakaba-itaza-picker', ItazaPicker);
})();
